module.exports = __webpack_public_path__ + "img/user.d35e4c87.png";